export enum TButtonAndLinkDesigns {
  LocalLinkPrim = 'LocalLinkPrim',
  LocalLinkSec = 'LocalLinkSec',
  LocalBttnPrim = 'LocalBttnPrim',
  LocalBttnSec = 'LocalBttnSec',
  LocalBttnSecTransp = 'LocalBttnSecTransp',
  LocalBttnSecHalfTransp = 'LocalBttnSecHalfTransp',
  LocalBttnCritical = 'LocalBttnCritical',
  LocalBttnLiquidGlass = 'LocalBttnLiquidGlass',
}
